export enum SessionStorageKeys {
  CONTACT_PERM = 'contact_perm',
  TWA_WS_URL = 'twaWsUrl',
  TWA_PORT = 'twaPort',
  IS_TWA = 'isTwa',
  IS_WEBVIEW = 'isWebview',
  REFRESH_COUNT = 'refreshCount',
  LOCATION_SEARCH = 'locationSearch',
}

export enum ContactPermission {
  allow = 'allow',
}

export interface OpenInstallTwaPageState {
  open: boolean
  mode?: string
  force?: boolean
}
